// constants
import { scriptTypes } from 'constants/scripts';

export const parseProductYears = ([ applicationSeasonCode, fertilitySeasonCode, plantingSeasonCode ]) => ({
  [scriptTypes.APPLICATION]: parseInt(applicationSeasonCode.substr(0,4), 10),
  [scriptTypes.FERTILITY]: parseInt(fertilitySeasonCode.substr(0,4), 10),
  [scriptTypes.PLANTING]: parseInt(plantingSeasonCode.substr(0,4), 10)
});
